/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  resetPassword: {
    id: "ResetPasswordSucceededPageComponent.resetPassword",
    defaultMessage: "You have requested to reset your password.",
  },
  resetPasswordSucceeded: {
    id: "ResetPasswordSucceededPageComponent.resetPasswordSucceeded",
    defaultMessage: "Please check your e-mail for verification link.",
  },
  resetPasswordButton: {
    id: "ResetPasswordSucceededPageComponent.button",
    defaultMessage: "Login",
  },
});

export default MESSAGES;